<template>
  <v-app>
    <default-bar
      v-if="useFadedAppBar"
      flat
      color="transparent"
      scroll-behavior="fade-image inverted"
      image="https://via.placeholder.com/10x10/FFFFFF/FFFFFF"
    />
    <default-bar v-else />
    <v-main style="min-width: 0px">
      <router-view />
    </v-main>
    <PreFooter
      v-if="
        route.name !== 'ScheduleAppointment' &&
        route.name !== 'CGU' &&
        route.name !== 'DataPolicy' &&
        route.name !== 'PractitionerPresentation' &&
        route.name !== 'Mission'
      "
    />
    <holi-footer></holi-footer>
    <pre-signup-dialog
      @close="global.preSignupDialogOpen = false"
      v-model="global.preSignupDialogOpen"
    />
    <donation-dialog
      @close="global.donationDialogOpen = false"
      v-model="global.donationDialogOpen"
    />
  </v-app>
</template>

<script lang="ts" setup>
import DefaultBar from './AppBar.vue'
import AppFooter from '@/layouts/default/AppFooterV2.vue'
import HoliFooter from '@/layouts/default/HoliFooter.vue'
import PreFooter from '@/layouts/default/PreFooter.vue'
import PreSignupDialog from '@/components/PreSignupDialog.vue'
import DonationDialog from '@/components/DonationDialog.vue'
import { computed } from 'vue'

import { useAppStore } from '@/store/app'
import { useRoute } from 'vue-router'

const route = useRoute()
const global = useAppStore()

const useFadedAppBar = computed(() => {
  const fadedRoutes = ['Home', 'PractitionerPresentation']
  return route.name && fadedRoutes.includes(<string>route.name)
})
</script>

<style scoped lang="scss"></style>
